// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";

// internal
import * as s from "./PricingFaq.styles";
import { IProps, IState, IContainer } from "./PricingFaq.d";

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import { Divider, IconButton } from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";

class PricingFaqComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  public render() {
    const { classes, question, answer } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.container}>
        <div
          className={classes.questionContainer}
          onClick={() => this.setState({ expanded: !this.state.expanded })}
        >
          <IconButton>
            <AddCircle classes={{ root: classes.icon }} />
          </IconButton>
          <div>{question}</div>
        </div>
        <div className={expanded ? classes.answerContainerShown : classes.answerContainerHidden}>
          {answer}
        </div>
        <Divider className={classes.divider} />
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////

export const PricingFaqStyled = withStyles(s.styles)(PricingFaqComponent);

///////////
// Redux //
///////////

function mapStateToProps(_state: any, _ownProps: IContainer) {
  return {}; // add redux state here, if needed
}

export const PricingFaq = connect(mapStateToProps, {})(PricingFaqStyled);
